import React from 'react';
import BingMapsReact from 'bingmaps-react';

const Maps = (props) => {
    const { latitude, longitude } = props;
    const bingKey = 'Ar_63k3NT5HX0Z-_G08y0GdByi2yXutgvQjlXyiZIjIHtjflXLpewTSinPnkL0yM';
    const location = {
        center: {
            longitude,
            latitude,
        },
        color: 'blue',
    };
    const pushPins = [location];
    return (React.createElement(BingMapsReact, { bingMapsKey: bingKey, height: '500px', width: '500px', center: [latitude, longitude], viewOptions: location, pushPins: pushPins, zoom: 9 }));
};

export { Maps };
